import styled from '@emotion/styled'
import { Box, DialogTitle } from '@mui/material'
import CloseIcon from '@mui/icons-material/Close'

export const StyledDialogInner = styled(Box)(() => ({
  width: '656px',
}))

export const StyledDialogTitleBox = styled(Box)(() => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  paddingRight: '24px',
  borderBottom: '1px solid #F0F0F0',
}))

export const StyledCloseIcon = styled(CloseIcon)(() => ({
  width: '20px',
  height: '20px',
  cursor: 'pointer',
}))

export const StyledDialogTitle = styled(DialogTitle)(() => ({
  fontSize: '20px',
  lineHeight: '24px',
}))
